export const MASTERS = [
    {
        code: "ME2108",
        title: "Nutrizione Applicata: Metabolismo, Dietetica e Psicologia dell’Alimentazione",
        label: "Master I Livello",
        image: "master-me2108-768x363.png",
        duration: "1 anno",
        slug: "nutrizione-applicata-metabolismo-dietetica-psicologia-alimentazione/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello/nutrizione-applicata-metabolismo-dietetica-psicologia-alimentazione/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2108/scheda-informativa-me2108.pdf?x97809",
        showMedal: true,
    },
    {
        code: "ME2111",
        title: "Management per le Funzioni di Coordinamento nell’Area delle Professioni Sanitarie",
        label: "Master I Livello - 8° edizione",
        image: "master-management-professioni-sanitarie-768x461.png",
        duration: "1500 ore",
        slug: "management-funzioni-coordinamento-area-professioni-sanitarie/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello-8-edizione/management-funzioni-coordinamento-area-professioni-sanitarie/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2111/scheda-informativa-master-i-livello-in-management-per-le-funzioni-di-coordinamento-nellarea-delle-professioni-sanitarie0a.pdf?x97809",
    },
    {
        code: "ME2005",
        title: "Infermieristica in Area Critica",
        label: "Master I Livello - 7° edizione",
        image: "infermieristica-area-critica-768x461.png",
        duration: "1500 ore",
        slug: "infermieristica-area-critica/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello-7-edizione/infermieristica-area-critica/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2005/scheda-informativa-master-infermieristica-in-area-critica.pdf?x97809",
    },
    {
        code: "ME2104",
        title: "Ortopedia e Traumatologia Sportiva",
        label: "Master I Livello - 7° edizione",
        image: "ortopedia-traumatologia-sportiva-768x461.png",
        duration: "1500 ore",
        slug: "ortopedia-traumatologia-sportiva/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello-7-edizione/ortopedia-traumatologia-sportiva/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2104/scheda-informativa-master-ortopedia-e-traumatologia-sportiva.pdf?x97809",
    },
    {
        code: "ME2103",
        title: "Posturologia Clinica",
        label: "Master I Livello - 7° edizione",
        image: "posturologia-clinica-768x461.png",
        duration: "1500 ore",
        slug: "posturologia-clinica/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello-7-edizione/posturologia-clinica/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2103/scheda-informativa-master-posturologia-clinica.pdf?x97809",
    },
    {
        code: "ME2102",
        title: "Deglutologia e Disturbi Correlati",
        label: "Master I Livello - 8° edizione",
        image: "deglutologia-disturbi-correlati-768x461.png",
        duration: "1500 ore",
        slug: "deglutologia-disturbi-correlati/",
        originalLink: "https://unicamillus.org/corsi/master-i-livello-8-edizione/deglutologia-disturbi-correlati/",
        pdfLink: "https://unicamillus.org/wp-content/uploads/master-online/i-livello/me2102/scheda-informativa-master-i-livello-in-deglutologia-e-disturbi-correlati.pdf?x97809",
    },/*
    {
        code: "ME2106",
        title: "Biorisonanza: Metodologie Applicative",
        label: "Master I Livello - 7° edizione",
        image: "biorisonanza-metodologie-applicative-768x461.png",
        duration: "1500 ore",
        slug: "master-i-livello-7-edizione/biorisonanza-metodologie-applicative/",
    },*/
];